import { CreditCardRounded } from '@mui/icons-material'
import { Box, Stack, Typography } from '@mui/material'
import React from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

interface AuthenticationCellProps {
  rfid: string | null
  cardName: string | undefined | null
}

export const AuthenticationInfo: React.FC<AuthenticationCellProps> = ({ rfid, cardName = '' }) => {
  const { t } = useCustomTranslation()

  if (!rfid) {
    return (
      <Typography component={'span'} variant="body2" color="text.disabled">
        {t('emobility.chargingSession.noAuthentication')}
      </Typography>
    )
  }

  if (!cardName)
    return (
      <Stack direction="row" spacing={2}>
        <CreditCardRounded />

        <Typography variant="body2" component={'span'} alignSelf="center" sx={{ overflowWrap: 'anywhere', hyphens: 'auto' }}>
          {t('emobility.chargingSession.authenticationInfoRfid', '', { rfid, label: 'RFID' })}
        </Typography>
      </Stack>
    )

  return (
    <Stack direction="row" alignItems={'center'} spacing={2}>
      <CreditCardRounded />

      <Box>
        <Typography variant="body2" sx={{ overflowWrap: 'anywhere', hyphens: 'auto' }}>
          {cardName}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            overflowWrap: 'anywhere',
            hyphens: 'auto',
            lineHeight: 1.2,
            color: theme => theme.palette.text.secondary,
          }}
        >
          {t('emobility.chargingSession.authenticationInfoRfid', '', { rfid, label: 'RFID' })}
        </Typography>
      </Box>
    </Stack>
  )
}
